import React, { useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'

import Modal from 'components/Modal/Modal'

import image from './i/image.png'

import styles from './EndProjectModal.module.scss'

const EndProjectModal = ({ data, onCloseModal, onEndProject }) => {
    const { t } = useTranslation()
    const [isDeactivating, setIsDeactivating] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)

    return (
        <Modal isShowCloseIcon onClose={onCloseModal}>
            <div className={styles.endProjectModal}>
                {isSuccess ? (
                    <>
                        <h3 className={styles.successTitle}>{t('The project has been successfully ended.')}</h3>
                        <p className={styles.successNote}>
                            <Trans
                                i18nKey="To make it available again, adjust the project’s active dates in the editor and republish the project. <lnk>Learn more</lnk>"
                                components={{
                                    lnk: (
                                        <a href="https://help.interacty.me/en/content/how-to-set-a-start-and-end-date-for-your-project-active-period" />
                                    ),
                                }}
                            />
                        </p>
                        <div className={styles.buttons}>
                            <button className="button" data-size="md" data-variant="primary" onClick={onCloseModal}>
                                {t('All clear')}
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <h3 className={styles.title}>{t('Are you sure you want to end\nthe project now?')}</h3>
                        {data.limitActivePeriod ? (
                            <>
                                <p className={styles.subTitle}>
                                    {t(
                                        'The link will remain active, but users will see the project end page you created.',
                                    )}
                                </p>
                            </>
                        ) : (
                            <>
                                <p className={styles.subTitle}>
                                    {t(
                                        'The link will remain active, but users will see a default page with the message:',
                                    )}
                                </p>
                                <div className={styles.imageContainer}>
                                    <img className={styles.image} src={image} alt="" />
                                    <div className={styles.imageText}>
                                        <h5 className={styles.imageTitle}>
                                            {t("This was a limited-time experience, and it's now closed.")}
                                        </h5>
                                        <h4 className={styles.imageSubTitle}>{t('Thanks for joining us!')}</h4>
                                    </div>
                                </div>
                                <div className={styles.note}>
                                    <Trans
                                        i18nKey="Tip: You can set a custom end date and design your own closing page in the editor. <lnk>Learn more here</lnk>"
                                        components={{
                                            lnk: (
                                                <a href="https://help.interacty.me/en/content/how-to-set-a-start-and-end-date-for-your-project-active-period" />
                                            ),
                                        }}
                                    />
                                </div>
                            </>
                        )}
                        <div className={styles.buttons}>
                            <button
                                disabled={isDeactivating}
                                className="button"
                                data-size="md"
                                data-variant="primary-danger"
                                onClick={async evt => {
                                    try {
                                        setIsDeactivating(true)
                                        await onEndProject(data, evt)
                                        await setIsSuccess(true)
                                    } catch (err) {
                                        console.error(err)
                                    } finally {
                                        setIsDeactivating(false)
                                    }
                                }}
                            >
                                {t('End Project')}
                            </button>
                            <button className="button" data-size="md" data-variant="secondary" onClick={onCloseModal}>
                                {t('Cancel')}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </Modal>
    )
}

export default EndProjectModal
